module.exports = __webpack_public_path__ + "static/media/bg-friend-balloon.8c12e19f.svg";